var _circle, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAmenitiesIconsCafe(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    height: 32,
    viewBox: "0 0 32 32",
    width: 32,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    fill: "#b7945e",
    r: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m12.4488 8.05273c-.3047.21876-.5517.50842-.7195.84397-.1677.33554-.2513.70689-.2434 1.08196-.0079.37504.0757.74644.2434 1.08194.1678.3356.4148.6252.7195.844",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m16.3009 8.05273c-.3048.21876-.5517.50842-.7195.84397-.1678.33554-.2513.70689-.2435 1.08196-.0078.37504.0757.74644.2435 1.08194.1678.3356.4147.6252.7195.844",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m7.63428 14.7969h13.48152v4.8148c0 1.5324-.6088 3.002-1.6923 4.0855-1.0836 1.0835-2.5532 1.6923-4.0855 1.6923h-1.9259c-1.5324 0-3.002-.6088-4.08555-1.6923-1.08354-1.0835-1.69227-2.5531-1.69227-4.0855z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m20.8711 21.2682c.4301.1975.902.2862 1.3744.2585s.9308-.171 1.3348-.4174c.404-.2463.7413-.5881.9823-.9954s.3782-.8675.3997-1.3402c.0214-.4727-.0736-.9435-.2767-1.3709s-.5081-.7983-.8882-1.0802c-.38-.282-.8235-.4662-1.2915-.5366-.4679-.0703-.946-.0247-1.3921.133",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAmenitiesIconsCafe);
export default __webpack_public_path__ + "static/media/AmenitiesIconsCafe.a7e6d07daec45c523a621526cba0cc6d.svg";
export { ForwardRef as ReactComponent };